import styled from 'styled-components';
import { rgba } from 'polished';
import { theme } from '../../styles/config/theme';
import { typeStyle } from '../../styles/config/typeStyles';
import { Link } from 'react-router-dom';

const StyledContainer = styled.div`
  width: 100%;
`;

const StyledTitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  svg {
    width: 17px;
    margin-right: 8px;
  }
`;

const StyledTitle = styled.h2`
  ${typeStyle['font-14-semi-bold']}
  text-transform: uppercase;
`;

const StyledList = styled.ul`
  margin-bottom: 55px;
`;

const StyledListItem = styled.li`
  padding: 20px 0 20px 18px;
  border-bottom: 1px solid ${rgba(theme.color.white, 0.1)};
`;

const StyledListLink = styled(Link)`
  position: relative;
  ${typeStyle['font-12-semi-bold']};
  letter-spacing: 0.5px;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: -10px;
    width: 4px;
    height: 4px;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background-color: ${props => theme.color[props.circle]};
  }
`;

const StyledDescContainer = styled.div`
  margin-bottom: 20px;
`;

const StyledDescHeading = styled.h3`
  margin-bottom: 7px;
  ${typeStyle['font-12-medium']}
`;

const StyledDescText = styled.p`
  ${typeStyle['font-10']}
`;

const StyledIconsList = styled.ul`
  display: flex;
  align-items: center;
  margin-bottom: 7px;
  padding-bottom: 20px;
  border-bottom: 1px solid ${rgba(theme.color.white, 0.1)};
`;

const StyledIconsItem = styled.li`
  &:not(:last-of-type) {
    margin-right: 22px;
  }
`;

const StyledIconsLink = styled.a`
  svg {
    width: 14px;
    height: 14px;
  }
`;

const StyledExtraList = styled.ul`
  display: flex;
  justify-content: space-between;
`;

const StyledExtraItem = styled.li`
  opacity: 0.6;
`;

const StyledExtraLink = styled(Link)`
  display: inline-block;
  padding: 11px 0;
  ${typeStyle['font-10']}
`;

export {
  StyledContainer,
  StyledTitleContainer,
  StyledTitle,
  StyledList,
  StyledListItem,
  StyledListLink,
  StyledDescContainer,
  StyledDescHeading,
  StyledDescText,
  StyledIconsList,
  StyledIconsItem,
  StyledIconsLink,
  StyledExtraList,
  StyledExtraItem,
  StyledExtraLink,
};
